import APLabel from './APLabel';

export {
  APLabel
};

export default APLabel;
